/* global HOME_PATH */
import React from 'react';
import { Button } from 'react-bootstrap';

function Login() {
  return (
    <Button
      bsStyle='default'
      className='btn-cta'
      href={HOME_PATH + '/signin'}
      target='_blank'
      >
      登录
    </Button>
  );
}

Login.displayName = 'Login';

export default Login;



// WEBPACK FOOTER //
// ./src/components/Header/components/Login.js